export function MobileAppBadges({ className = '' }) {
    return (
        <div className={`flex flex-wrap items-center gap-3 ${className}`}>
            <a href="#" className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/15 border border-white/20 rounded-xl transition-all duration-300 group" data-testid="app-store-badge">
                <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                <div className="text-left">
                    <p className="text-[10px] text-white/50 leading-none">Télécharger sur</p>
                    <p className="text-sm font-semibold text-white leading-tight">App Store</p>
                </div>
            </a>
            <a href="#" className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/15 border border-white/20 rounded-xl transition-all duration-300 group" data-testid="play-store-badge">
                <svg className="w-6 h-6" viewBox="0 0 24 24">
                    <path fill="#34A853" d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92z"/>
                    <path fill="#FBBC05" d="M16.247 15.055l-2.455-1.456L3.609 22.186A1.078 1.078 0 0 0 4.64 22.5l11.606-7.445z"/>
                    <path fill="#4285F4" d="M21.601 12l-3.401-1.947L16.247 8.945l-2.455 3.055l2.455 3.055l1.953-1.108L21.601 12a1 1 0 0 0 0-2z"/>
                    <path fill="#EA4335" d="M3.609 1.814L13.792 12l2.455-3.055L4.64 1.5a1.078 1.078 0 0 0-1.031.314z"/>
                </svg>
                <div className="text-left">
                    <p className="text-[10px] text-white/50 leading-none">Disponible sur</p>
                    <p className="text-sm font-semibold text-white leading-tight">Google Play</p>
                </div>
            </a>
        </div>
    );
}
